import { jsx as t, jsxs as l } from "react/jsx-runtime";
import "react";
var r = (i) => /* @__PURE__ */ l("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-186 -900)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10 15.0001C12.7614 15.0001 15 12.7615 15 9.99999C15 7.2385 12.7614 4.99988 10 4.99988C7.23858 4.99988 5 7.2385 5 9.99999C5 12.7615 7.23858 15.0001 10 15.0001Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10.6167 8.08813L11.4745 9.27023L12.8637 8.81979L12.0046 10.0008L12.8623 11.1829L11.4735 10.7307L10.6144 11.9118L10.6153 10.4513L9.22656 9.99915L10.6158 9.54871L10.6167 8.08813Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M11.136 12.9546C9.50426 12.9546 8.18145 11.6318 8.18145 9.99997C8.18145 8.36814 9.50422 7.04534 11.136 7.04534C11.6448 7.04534 12.1235 7.17397 12.5414 7.40046C11.8858 6.75928 10.9891 6.36353 9.99961 6.36353C7.99137 6.36353 6.36328 7.99161 6.36328 9.99997C6.36328 12.0083 7.99141 13.6365 9.99969 13.6365C10.9892 13.6365 11.8859 13.2407 12.5415 12.5995C12.1236 12.8259 11.6448 12.9546 11.136 12.9546Z",
      fill: "#D80027"
    })
  ]
});
export {
  r as default
};
